import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Eye, FileText } from 'lucide-react';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-black pt-28 pb-12 px-6">
            <div className="max-w-4xl mx-auto space-y-12">
                {/* Header */}
                <div className="text-center space-y-4">
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-4xl md:text-5xl font-serif font-bold text-gradient"
                    >
                        Privacy Policy
                    </motion.h1>
                    <p className="text-gray-400">Last Updated: December 2025</p>
                </div>

                {/* Content Card */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    className="glass-card p-8 md:p-12 rounded-2xl space-y-8"
                >
                    <Section
                        icon={<Shield className="w-6 h-6 text-gold-500" />}
                        title="1. Information We Collect"
                        content="We collect information that you provide directly to us when you place an order, create an account, or contact us. This includes your name, phone number, delivery address, and payment information. We use this data solely for the purpose of fulfilling your orders and improving our service."
                    />

                    <Section
                        icon={<Eye className="w-6 h-6 text-gold-500" />}
                        title="2. How We Use Your Data"
                        content="Your data is used to: (a) Process and deliver your food orders; (b) Send you order status updates; (c) Improve our menu and website functionality; (d) Prevent fraud and ensure security. We do strictly NOT sell your personal data to third parties."
                    />

                    <Section
                        icon={<Lock className="w-6 h-6 text-gold-500" />}
                        title="3. Data Security"
                        content="We implement industry-standard security measures to protect your personal information. Your password is encrypted, and sensitive payment details are processed securely by our payment partners. However, no method of transmission over the Internet is 100% secure."
                    />

                    <Section
                        icon={<FileText className="w-6 h-6 text-gold-500" />}
                        title="4. Local Storage & Session Data"
                        content="We use local storage technology (similar to cookies) to store your login session and shopping cart contents directly on your device. This ensures you stay logged in and don't lose your cart items even if you close the browser. We do not use third-party tracking cookies or pixel tags."
                    />

                    <div className="pt-8 border-t border-white/10">
                        <h3 className="text-gold-400 font-bold text-lg mb-2">Contact Us</h3>
                        <p className="text-gray-400">If you have any questions about this Privacy Policy, please contact us via the form on our Contact page.</p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

const Section = ({ icon, title, content }) => (
    <div className="space-y-3">
        <div className="flex items-center gap-3">
            {icon}
            <h2 className="text-xl font-bold text-white">{title}</h2>
        </div>
        <p className="text-gray-400 leading-relaxed pl-9">
            {content}
        </p>
    </div>
);

export default PrivacyPolicy;
